import { render, staticRenderFns } from "./SimulatorRemittance.vue?vue&type=template&id=1c01ce78&scoped=true"
import script from "./SimulatorRemittance.vue?vue&type=script&lang=js"
export * from "./SimulatorRemittance.vue?vue&type=script&lang=js"
import style0 from "./SimulatorRemittance.vue?vue&type=style&index=0&id=1c01ce78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01ce78",
  null
  
)

export default component.exports